// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Breadcrumb_breadcrumb__n3dYg","breadcrumbTitle":"Breadcrumb_breadcrumbTitle__NdOLj","breadcrumbSeparator":"Breadcrumb_breadcrumbSeparator__76qwN"};